import { keyBy, flatten, get } from 'lodash'
import { toFieldPath } from '../fields/referenceFieldPath'
import { isReferenceField } from '../fields/fieldQueries'
import type {
  DigestedSchema,
  DigestedSchemaField,
  DigestedSimpleField,
  DigestedReferenceField,
} from '@wix/wix-data-client-common-standalone'
import type { FieldSpec, ReferenceField } from '@wix/wix-data-schema-types'

export const addReferencedFieldsToSchema = (
  digestedSchema: DigestedSchema,
  digestedReferencedSchemas: DigestedSchema[],
) => {
  const prefetchedSchemasById = keyBy(digestedReferencedSchemas, 'id')

  const getReferencedSchema = (referenceField: FieldSpec & ReferenceField) =>
    prefetchedSchemasById[referenceField.referencedCollection]

  // TODO: this does not belong here
  const enrichReferenceField = (
    referenceField: DigestedSimpleField & ReferenceField,
  ): DigestedReferenceField => ({
    ...referenceField,
    referencedCollectionDisplayField: get(
      getReferencedSchema(referenceField),
      'displayField',
    ),
  })

  const getReferencedSchemaFields = (
    referenceField: DigestedReferenceField,
  ): DigestedSimpleField[] =>
    get(getReferencedSchema(referenceField), 'fields', []).map(
      referencedSchemaField => ({
        ...referencedSchemaField,
        name: toFieldPath(referencedSchemaField.name, referenceField.name),
        referencingFieldLabel: referenceField.displayName,
        isDeleted: referenceField.isDeleted || referencedSchemaField.isDeleted,
      }),
    )

  const fieldsWithReferences = digestedSchema.fields.map(field =>
    isReferenceField(field)
      ? (
          [
            enrichReferenceField(field as DigestedSimpleField & ReferenceField),
          ] as DigestedSchemaField[]
        ).concat(
          getReferencedSchemaFields(
            field as DigestedSimpleField & ReferenceField,
          ),
        )
      : field,
  )

  return {
    ...digestedSchema,
    fields: flatten(fieldsWithReferences),
  }
}
